import resolveConfig from 'tailwindcss/resolveConfig';
import config from '../tailwind.config.esm.js';

// @ts-ignore - No types package for tailwind
var tailwindConfig = /*#__PURE__*/resolveConfig(config);

export { tailwindConfig };
//# sourceMappingURL=tailwind.esm.js.map
